export default "<ion-header>\n  <ion-toolbar>\n    <ion-title>newOrder</ion-title>\n  </ion-toolbar>\n</ion-header>\n\n<ion-content>\n\n</ion-content>\n"